import { render, staticRenderFns } from "./yToggle.vue?vue&type=template&id=0d06f7bf&scoped=true"
import script from "./yToggle.vue?vue&type=script&lang=js"
export * from "./yToggle.vue?vue&type=script&lang=js"
import style0 from "./yToggle.vue?vue&type=style&index=0&id=0d06f7bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06f7bf",
  null
  
)

export default component.exports